(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("checkbox", [], factory);
	else if(typeof exports === 'object')
		exports["checkbox"] = factory();
	else
		root["checkbox"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 